var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"float-nav"},_vm._l((_vm.anchorItems),function(item){return _c('a',{key:item.key,staticClass:"float-nav__link",class:{ active: _vm.activeAnchor === item.key },on:{"click":function($event){return _vm.$emit('scroll-to', item.key)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }